import { FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';

import { CloseButton } from '../../components/buttons/CloseButton';
import { AssetTitle } from '../../components/AssetTitle/AssetTitle';
import { IconButton } from '../../components/IconButton/IconButton';
import { getImageSrc } from '../../utils/image';
import { getAssetImage } from '../../../../utils/player/asset';
import { usePlayerContainer } from '../../hooks/usePlayerContainer';
import { useUpNextCountdownControls } from '../../hooks/useUpNextCountdownControls';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';
import { useIcons } from '../../hooks/useIcons';

interface FloatingUpNextLayoutProps {
  onCancelClick: () => void;
  upNextState: 'idle' | 'preview' | 'post-countdown' | 'canceled' | 'playNext';
}

const END_SCREEN_COUNTDOWN_IN_SECONDS = 4;

export const FloatingUpNextLayout: FunctionComponent<
  FloatingUpNextLayoutProps
> = ({ onCancelClick, upNextState }) => {
  const { trackImpressionUIElement } = useTpaasTracker();
  const { Play, Replay } = useIcons();
  const playerContainer = usePlayerContainer();
  const isCountdownMode = upNextState === 'post-countdown';
  const {
    nextAsset,
    progressPercentage,
    handleSkipClick,
    handleReplayClick,
    handleCancelClick,
  } = useUpNextCountdownControls({
    enabled: isCountdownMode,
    countdownInSeconds: END_SCREEN_COUNTDOWN_IN_SECONDS,
    onCancel: onCancelClick,
  });

  useEffect(() => {
    trackImpressionUIElement({
      elementType: 'div',
      name: 'PlayNextCountdown',
    });
  }, [trackImpressionUIElement]);

  const posterSrc = getImageSrc(
    getAssetImage(nextAsset!, 'main'),
    playerContainer.clientWidth
  );

  return (
    <div
      className="vgp-floating-up-next"
      style={{ backgroundImage: `url(${posterSrc})` }}
    >
      <CloseButton
        onClick={handleCancelClick}
        className="vgp-floating-up-next-close"
        color="secondary"
        size="xsmall"
      />
      <div className="vgp-floating-up-next-bottom">
        <div className="vgp-floating-up-next-title">
          <AssetTitle asset={nextAsset!} isSmall />
        </div>
        <div className="vgp-floating-up-next-buttons">
          <IconButton
            onClick={handleReplayClick}
            color="secondary"
            size="xsmall"
          >
            <Replay />
          </IconButton>
          <IconButton
            onClick={handleSkipClick}
            color="primary"
            size="xsmall"
            className="vgp-floating-up-next-skip"
          >
            {isCountdownMode && (
              <span
                className="vgp-floating-up-next-progress"
                style={{
                  width: `${progressPercentage}%`,
                }}
              />
            )}
            <span className="vgp-floating-up-next-skip-icon">
              <Play />
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
};
